// (function () {
    var EyeGlassBuilder = {
        attributes: {
            disabled: "disabled",
        },
    
        selectors: {
            steps: "eyeglass-builder-step",
            preview: "bundle-options",
            step1Options: "input[name='lens_type']",
            step2Options: "input[name='choose_add_ons']",
            step3Options: "input[name='lens-design']",
            eyeglassBuilderDrawer: "eyeglass-builder",
            mobileSummary: "js-mobile-summary",
            backButton: "bundle--back",
            skipButton: "skip-button",
            toggleSummary: "js-toggle-summary",
            step1: "[data-step='1']",
            step2: "[data-step='2']",
            step3: "[data-step='3']",
            step4: "[data-step='4']",
            step5: "[data-step='5']",
            dataStepChanger: "[data-step-changer]",
            addBundleToCart: "add-builder-to-cart",
            builderSubtotal: "js-subtotal",
            progressButtons: "progress_bar-buttons",
            builderClose: ".drawer__close-button.js-closePopup"
        },
    
        labels: {
            makeSelection: "Make a selection",
            chooseAddOns: "Choose Add-Ons",
            choosePower: "Choose Power",
            chooseLensDesign: "Choose Lens Design",
            addToCart: "Add to cart",
        },
    
        elements: function () {
            return {
                preview: document.querySelectorAll(`.${this.selectors.preview}`),
                builderDrawer: document.querySelector(`.${this.selectors.eyeglassBuilderDrawer}`),
                allSteps: document.querySelectorAll(`.${this.selectors.steps}`),
                step1Container: document.querySelector(`${this.selectors.step1}`),
                step2Container: document.querySelector(`${this.selectors.step2}`),
                step3Container: document.querySelector(`${this.selectors.step3}`),
                step4Container: document.querySelector(`${this.selectors.step4}`),
                step5Container: document.querySelector(`${this.selectors.step5}`),
                builderSubtotal: document.querySelectorAll(`.${this.selectors.builderSubtotal}`),
                mobileSummary: document.querySelector(`.${this.selectors.mobileSummary}`),
                toggleSummary: document.querySelector(`.${this.selectors.toggleSummary}`),
                dataStepChanger: document.querySelector(`${this.selectors.dataStepChanger}`),
                backButton: document.querySelectorAll(`.${this.selectors.backButton}`),
                skipButtons: document.querySelectorAll(`.${this.selectors.skipButton}`),
                addBundleToCartBtn: document.querySelector(`.${this.selectors.addBundleToCart}`),
                progressButtons: document.querySelectorAll(`.${this.selectors.progressButtons}`),
                products: JSON.parse(document.querySelector("#eyeglass_builder").innerText),
                variantPicker: document.querySelector('product-variants'),
                builderCloseBtn: document.querySelector(`${this.selectors.builderClose}`),
    
            };
        },
    
        init: function () {
            if (!document.querySelector(".eyeglass-builder")) return;
            this.bindEvents();
        },
    
        state: {
            currentStep: 1,
            prevStep: 0,
            stepCount: 1,
            step1Value: false,
            step2Value: false,
            step3Value: false,
            step4Value: false,
            step5Value: false,
            number_of_steps: false,
        },
    
        bindEvents: function () {
            let _ = this;
            console.log("===",this.elements().products)
            this.elements().step1Container.querySelectorAll(this.selectors.step1Options).forEach((step1option) => step1option.addEventListener("change", _.handleStep1Change.bind(this), true));
            this.elements().step2Container.querySelectorAll(this.selectors.step2Options).forEach((step2option) => step2option.addEventListener("change", _.handleStep2Change.bind(this), true));
            this.elements().step3Container.querySelectorAll(this.selectors.step3Options).forEach((step3option) => step3option.addEventListener("change", _.handleStep3Change.bind(this), true));
    
            this.elements().dataStepChanger.addEventListener("click", _.handleNextClick.bind(this), true);
            this.elements().backButton.forEach((backButton) => backButton.addEventListener("click", _.handleBackClick.bind(this), true));
            this.elements().skipButtons.forEach((skipButton) => skipButton.addEventListener("click", _.handleSkip.bind(this), true));
            this.elements().addBundleToCartBtn.addEventListener('click', _.handleAddToCart.bind(this), true);
            this.elements().progressButtons.forEach((progressButtons) => progressButtons.addEventListener("click", _.handleProgressButtonClick.bind(this), true));
            this.elements().toggleSummary.addEventListener("click", _.handleSummaryToggle.bind(this), true);
            this.elements().builderCloseBtn.addEventListener('click', _.resetBuilder.bind(this), true);
            window.addEventListener("builderCB:changed", _.handleStep2Change.bind(this), true);
    
            document.querySelector(".skip-button_plus_add_to_cart").addEventListener("click", _.handleAddToCart.bind(this), true);
    
            document.addEventListener("variant:changed", function () {
                setTimeout(() => {
                    _.resetBuilder();
                }, 10);
            });
    
            // console.log(this.elements().builderCloseBtn);
            // this.elements().builderCloseBtn.addEventListener('click', function (evt) {
            //     evt.preventDefault();
            //     _.resetBuilder();
            // }, true);
        },
    
        handleSummaryToggle: function () {
            this.elements().mobileSummary.classList.toggle("is-active");
        },
    
        handleStep1Change: function ({ currentTarget }) {
            this.state.step1Value = { title: currentTarget.value, data: currentTarget.getAttribute('data-value'), price: parseInt(currentTarget.getAttribute("data-price")) };
            // this.elements().step3Container.querySelectorAll(".not-high-index").forEach((element) => element.classList.remove('hidden'));
    
            if (this.state.step1Value.data === "sv") {
                this.elements().step3Container.querySelectorAll(".step-lens-design").forEach((element) => element.classList.add("hidden"));
                this.elements().step3Container.querySelectorAll(".step-lens-design.for-single-vision").forEach((element) => element.classList.remove("hidden"));
            }
    
            if (this.state.step1Value.data === "prg") {
                this.elements().step3Container.querySelectorAll(".step-lens-design").forEach((element) => element.classList.add("hidden"));
                this.elements().step3Container.querySelectorAll(".step-lens-design.for-progressive-prescription").forEach((element) => element.classList.remove("hidden"));
            }
    
            if (this.state.step1Value.data === "rr") {
    
            }
            this.elements().step1Container.querySelector(".progress-bar-wrapper").classList.remove("tw-invisible");
    
            // Reset all next steps
            // Step2 Reset
            this.elements().step2Container.querySelectorAll(this.selectors.step2Options).forEach((step2option) => step2option.checked = false);
    
            // Step3 Reset
            this.elements().step3Container.querySelectorAll(this.selectors.step3Options).forEach((step3option) => step3option.checked = false);
    
            this.changeButtonState();
            this.state.step2Value = false;
            this.state.step3Value = false;
        },
    
        handleStep2Change: function (event) {
            let _ = this;
            this.elements().step2Container.querySelector(".sub-step:not(.hidden)").querySelector(".progress-bar-wrapper").classList.remove("tw-invisible");
            if (this.state.step1Value.data !== "rr") {
                let selectedValues = Array.from(_.elements().step2Container.querySelectorAll(_.selectors.step2Options)).filter((step2option) => step2option.checked);
                selectedValues = selectedValues.map((element) => {
                    return { title: element.value, data: element.getAttribute("data-value"), price: parseInt(element.getAttribute("data-price")) }
                });
                // this.elements().step3Container.querySelectorAll(".not-high-index").forEach((element) => element.classList.remove('hidden'));
                if (selectedValues.length) {
                    this.state.step2Value = selectedValues;
                    let valuesOfStep2 = this.state.step2Value.map((step2Value) => step2Value.data);
                    // if (selectedValues.length && valuesOfStep2.indexOf("hi") !== -1) {
                    //     this.elements().step3Container.querySelectorAll(".not-high-index").forEach((element) => element.classList.add('hidden'));
                    // }
                } else {
                    this.state.step2Value = false;
                }
            } else {
                this.state.step2Value = [{ title: 'Ready readers', value: event.detail.selectedValue, price: 0 }];
            }
            // document.querySelector(".eyeglass-builder__wrapper").querySelectorAll(`.${this.selectors.progressButtons}[data-progress='3']`).forEach((progressButton) => progressButton.removeAttribute("disabled"));
            this.state.step3Value = false;
            this.changeButtonState();
            this.updatePreview();
        },
    
        handleStep3Change: function ({ currentTarget }) {
            this.state.step3Value = { title: currentTarget.getAttribute("value"), value: currentTarget.getAttribute("data-value"), price: parseInt(currentTarget.getAttribute("data-price")) };
            this.elements().step3Container.querySelector(".progress-bar-wrapper").classList.remove("tw-invisible"); this.elements().step1Container.querySelector(".progress-bar-wrapper").querySelector(".addons-step1").classList.remove("hidden");
            // document.querySelector(".eyeglass-builder__wrapper").querySelectorAll(`.${this.selectors.progressButtons}[data-progress='3']`).forEach((progressButton) => progressButton.removeAttribute("disabled"));
            this.changeButtonState();
        },
    
        handleBackClick: function ({ currentTarget }) {
            if (this.state.currentStep != 1) {
                document.querySelector(".eyeglass-builder__wrapper").querySelectorAll(`.${this.selectors.progressButtons}[data-progress='${this.state.currentStep}']`).forEach((progressButton) => progressButton.setAttribute("disabled", ""));
            }
            this.state.currentStep = this.state.currentStep - 1;
            this.handleStepChange("prev");
        },
    
        handleNextClick: function () {
            this.state.currentStep = this.state.currentStep + 1;
            this.handleStepChange("next");
        },
    
        handleProgressButtonClick: function ({ currentTarget }) {
            if (currentTarget.hasAttribute("disabled")) {
                return;
            }
            this.state.currentStep = parseInt(currentTarget.getAttribute('data-progress'));
            for (let index = this.state.currentStep; index <= 3; index++) {
                if(index != 1) document.querySelector(".eyeglass-builder__wrapper").querySelectorAll(`.${this.selectors.progressButtons}[data-progress='${index}']`).forEach((progressButton) => progressButton.setAttribute("disabled", ""));
            }
            this.updatePreview();
            this.handleStepChange();
        },
    
    
        handleStepChange: function () {
            this.elements().allSteps.forEach((step) => step.classList.add("hidden"));
            let button = this.elements().dataStepChanger;
            let addToCart = this.elements().addBundleToCartBtn;
    
            const enableButton = (isFinal) => {
                button.removeAttribute(this.attributes.disabled, true);
                isFinal ? (button.classList.add("hidden"), addToCart.classList.remove("hidden")) : (button.classList.remove("hidden"), addToCart.classList.add("hidden"));
            };
    
            const disableButton = () => {
                button.setAttribute(this.attributes.disabled, true);
                button.querySelector(".button-text").innerText = this.labels.makeSelection;
            };
    
            this.elements().step1Container.querySelectorAll(".progress-bar-wrapper").forEach((progressBarWrapper) => {
                progressBarWrapper.querySelectorAll(".progress-bar-options").forEach((progressBarOptions) => progressBarOptions.classList.add("hidden"));
    
            });
            this.elements().step2Container.querySelectorAll(".progress-bar-wrapper").forEach((progressBarWrapper) => {
                progressBarWrapper.querySelectorAll(".progress-bar-options").forEach((progressBarOptions) => progressBarOptions.classList.add("hidden"));
            });
            this.elements().step3Container.querySelectorAll(".progress-bar-wrapper").forEach((progressBarWrapper) => {
                // progressBarWrapper.querySelectorAll(".progress-bar-options").forEach((progressBarOptions) => progressBarOptions.classList.add("hidden"));
            });
    
            const firstImage = document.querySelector(".js-builder-image:not(.hidden)[data-current-index='2']");
            const secondImage = document.querySelector(".js-builder-image:not(.hidden)[data-current-index='1']");
            if (this.state.currentStep % 2 === 0) {
                secondImage && secondImage.classList.add("is-selected");
                if (secondImage) {
                    firstImage && firstImage.classList.remove("is-selected");
                }
            } else {
                secondImage && secondImage.classList.remove("is-selected");
                firstImage && firstImage.classList.add("is-selected");
            }
    
            switch (this.state.currentStep) {
                case 1: {
                    this.elements().step1Container.classList.remove("hidden");
    
                    this.state.step1Value ? enableButton() : disableButton();
    
                    button.querySelector(".button-text").innerText = this.labels.chooseAddOns;
                    if (this.state.step1Value.data === "sv" || this.state.step1Value.data === "prg") {
                        this.elements().step1Container.querySelector(".progress-bar-wrapper").querySelector(".addons-step1").classList.remove("hidden");
                        this.elements().step1Container.querySelector(".progress-bar-wrapper").classList.add("add-ons-steps-3");
                        this.elements().step1Container.querySelector(".progress-bar-wrapper").classList.remove("add-ons-steps-2");
                    }
    
                    if (this.state.step1Value.data === "rr") {
                        button.querySelector(".button-text").innerText = this.labels.choosePower;
                        this.elements().step1Container.querySelector(".progress-bar-wrapper").querySelector(".rr-step1").classList.remove("hidden");
                       this.elements().step1Container.querySelector(".progress-bar-wrapper").classList.add("add-ons-steps-2");
                      this.elements().step1Container.querySelector(".progress-bar-wrapper").classList.remove("add-ons-steps-3");
    
                    }
    
                    if (this.state.step1Value.data === "np") {
                        this.elements().step1Container.querySelector(".progress-bar-wrapper").querySelector(".np-step1").classList.remove("hidden");
                        this.elements().step1Container.querySelector(".progress-bar-wrapper").classList.add("add-ons-steps-2");
                        this.elements().step1Container.querySelector(".progress-bar-wrapper").classList.remove("add-ons-steps-3");
                    }
    
                    if (this.state.step1Value && this.state.step1Value.title == "frame-only") {
                        enableButton(true);
                        this.elements().step1Container.querySelector(".progress-bar-wrapper").querySelector(".addons-step1").classList.remove("hidden");
                        this.elements().step1Container.querySelector(".progress-bar-wrapper").classList.add("tw-invisible");
                        this.elements().step2Container.querySelectorAll(this.selectors.step2Options).forEach((step2option) => step2option.checked = false);
                        this.elements().step3Container.querySelectorAll(this.selectors.step3Options).forEach((step3option) => step3option.checked = false);
                        this.state.step2Value = false;
                        this.state.step3Value = false;
    
                    }
    
                    // Remove step 2 selected values from bottom-right
                    this.state.step2Value = false;
                    this.elements().step2Container.querySelectorAll(this.selectors.step2Options).forEach((step2option) => step2option.checked = false);
                    this.state.step3Value = false;
                    break;
                }
                case 2: {
                    this.elements().step2Container.classList.remove("hidden");
                    this.elements().step3Container.querySelectorAll(this.selectors.step3Options).forEach((step3option) => step3option.checked = false);
                    document.querySelector(".eyeglass-builder__wrapper").querySelectorAll(`.${this.selectors.progressButtons}[data-progress='2']`).forEach((progressButton) => progressButton.removeAttribute("disabled"));
                    document.querySelector(".eyeglass-builder__wrapper").querySelectorAll(`.${this.selectors.progressButtons}[data-progress='3']`).forEach((progressButton) => progressButton.setAttribute("disabled",""));
                    button.querySelector(".button-text").innerText = this.labels.chooseLensDesign;
    
                    switch (this.state.step1Value.data) {
                        case "rr": {
                            this.elements().step2Container.querySelector(".progress-bar-wrapper").querySelector(".rr-step1").classList.remove("hidden");
                            this.elements().step2Container.querySelector(".sub-step:not(.hidden)").querySelector(".rr-step1").classList.remove("hidden");
                            this.state.step2Value ? enableButton(true) : disableButton();
                            break;
                        }
                        case "np": {
                            this.elements().step2Container.querySelector(".progress-bar-wrapper").querySelector(".np-step1").classList.remove("hidden");
                            this.elements().step2Container.querySelector(".sub-step:not(.hidden)").querySelector(".np-step1").classList.remove("hidden");
                            enableButton(true);
                            break;
                        }
                        default: {
                            this.elements().step2Container.querySelector(".progress-bar-wrapper").querySelector(".addons-step1").classList.remove("hidden");
                            this.elements().step2Container.querySelector(".sub-step:not(.hidden)").querySelector(".addons-step1").classList.remove("hidden");
                            this.state.step2Value ? enableButton() : disableButton();
                            break;
                        }
                    }
                    // Remove step 3 value from right
                    this.state.step3Value = false;
                    this.elements().step3Container.querySelectorAll(this.selectors.step3Options).forEach((step3option) => step3option.checked = false);
                    break;
                }
                case 3: {
                    document.querySelector(".eyeglass-builder__wrapper").querySelectorAll(`.${this.selectors.progressButtons}[data-progress='3']`).forEach((progressButton) => progressButton.removeAttribute("disabled"));
                    this.elements().step3Container.classList.remove("hidden");
                    this.state.step3Value ? enableButton(true) : disableButton();
                    // switch (this.state.step1Value.data) {
                    //     case "rr": {
                    //         this.elements().step2Container.querySelector(".sub-step:not(.hidden)").querySelector(".rr-step1").classList.remove("hidden");
                    //         this.state.step2Value ? enableButton(true) : disableButton();
                    //         break;
                    //     }
                    //     case "np": {
                    //         this.elements().step2Container.querySelector(".sub-step:not(.hidden)").querySelector(".np-step1").classList.remove("hidden");
                    //         enableButton(true);
                    //         break;
                    //     }
                    //     default: {
                    //         this.elements().step3Container.querySelector(".progress-bar-wrapper").querySelector(".addons-step1").classList.remove("hidden");
                    //         this.state.step3Value ? enableButton() : disableButton();
                    //         break;
                    //     }
                    // }
                    break;
                }
                default: {
                    this.elements().builderDrawer.removeAttribute("open");
                    this.elements().step1Container.classList.remove("hidden");
                    this.resetBuilder();
                    disableButton();
                    break;
                }
    
    
            }
            this.updatePreview();
        },
    
        changeButtonState: function () {
            let button = this.elements().dataStepChanger;
            let currentStep = this.state.currentStep;
            button.setAttribute(this.attributes.disabled, true);
            button.querySelector(".button-text").innerText = this.labels.makeSelection;
    
            switch (currentStep) {
                case 1: {
                    let step1Value = this.state.step1Value.data;
                    if (step1Value === 'sv' || step1Value === 'prg') {
                        //console.log("Single Vision / Progressive prescription");
                        this.elements().step2Container.querySelector(".addons-step2").classList.remove("hidden");
                        this.elements().step2Container.querySelector(".rr-step2").classList.add("hidden");
                        this.elements().step2Container.querySelector(".np-step2").classList.add("hidden");
                    } else if (step1Value === "rr") {
                        //console.log("Ready Readers");
                        this.elements().step2Container.querySelector(".addons-step2").classList.add("hidden");
                        this.elements().step2Container.querySelector(".np-step2").classList.add("hidden");
                        this.elements().step2Container.querySelector(".rr-step2").classList.remove("hidden");
                    } else if (step1Value === "np") {
                        this.elements().step2Container.querySelector(".np-step2").classList.remove("hidden");
                        this.elements().step2Container.querySelector(".rr-step2").classList.add("hidden");
                        this.elements().step2Container.querySelector(".addons-step2").classList.add("hidden");
                    } else {
                        //console.log("Straight to Add to cart!");
                    }
                    break;
                }
                case 2: {
                    // this.handleStepChange();
                    break;
                }
    
                case 3: {
                    // this.handleStepChange();
                }
    
                default:
                    break;
            }
            this.handleStepChange();
        },
    
        handleSkip: function () {
            console.log(this.state.currentStep);
            this.elements()[`step${this.state.currentStep}Container`].querySelectorAll(`${this.selectors.step2Options}:checked`).forEach(radio => radio.checked = false);
            this.state[`step${this.state.currentStep}Value`] = false;
            this.state.currentStep = this.state.currentStep + 1;
            this.handleStepChange();
        },
    
        resetBuilder: function () {
            // Reset the builder state
            this.state = {
                currentStep: 1,
                prevStep: 0,
                stepCount: 1,
                step1Value: false,
                step2Value: false,
                step3Value: false,
                step4Value: false,
                step5Value: false,
                number_of_steps: false,
            };
    
            // Step 1 reset
            this.elements().allSteps.forEach((step) => step.classList.add("hidden"));
            this.elements().allSteps.forEach((step, index) => index === 0 && step.classList.remove("hidden"));
    
            this.elements().step1Container.querySelectorAll(this.selectors.step1Options).forEach((step1option) => step1option.checked = false);
            this.elements().step1Container.querySelector(".progress-bar-wrapper").querySelectorAll(".progress-bar-options").forEach((progressBarOption) => {
                if (progressBarOption.getAttribute("data-for") === "add-ons") {
                    progressBarOption.classList.remove("hidden");
                    progressBarOption.querySelectorAll(".progress_bar-buttons").forEach(function (eleme) {
                        if (eleme.getAttribute("data-progress") == "2" || eleme.getAttribute("data-progress") == 3) {
                            eleme.setAttribute("disabled", "");
                        }
                    })
                }
                else {
                    progressBarOption.classList.add("hidden");
                }
            });
            document.querySelector(".eyeglass-builder__wrapper").querySelectorAll(`.${this.selectors.progressButtons}[data-progress='2']`).forEach((progressButton) => progressButton.setAttribute("disabled",true));
            // data-for="add-ons"
            // Step 2 reset
            this.updatePreview();
            this.elements().step2Container.querySelectorAll(this.selectors.step2Options).forEach((step2option) => step2option.checked = false);
            // Step 3 reset
            this.elements().step3Container.querySelectorAll(this.selectors.step3Options).forEach((step3option) => step3option.checked = false);
            document.querySelectorAll(".lens-selection").forEach((lensSelection) => lensSelection.classList.add('hidden'));
            this.elements().dataStepChanger.classList.remove('hidden');
            this.elements().dataStepChanger.disabled = true;
            this.elements().dataStepChanger.innerHTML = `<span class="button-text">${this.labels.makeSelection} </span>`;
            this.elements().addBundleToCartBtn.classList.add('hidden');
            this.updatePreview(); 
        },
    
        generateSku: function () {
            let step1Value = this.state.step1Value.data,
                step2Value = this.state.step2Value.map((value) => value.data).join(","),
                step3Value = this.state.step3Value.value;
            return `opt-${step1Value}-${step3Value}${step2Value ? `-${step2Value}` : ``}`;
        },
    
        handleAddToCart: function () {
            let _ = this;
            let button = this.elements().addBundleToCartBtn;
            const bundleId = (new Date()).getTime();
            let itemsArray = [];
            // console.log("Adding product to cart!", this);
    
            button.setAttribute('aria-busy',true);
    
            const generateSku = () => {
                let step2Values = this.state.step2Value ? (this.state.step2Value.map((step2Value) => step2Value.data)).join("-") : false;
                return `opt-${this.state.step1Value.data}-${this.state.step3Value.value}${step2Values ? `-${step2Values}` : ``}`;
            };
    
            let selectedSku = generateSku();
            // console.log("Generated Sku", selectedSku);
    
            let opticalProduct = false, giftWithPurchase = false;
            // console.log("===",this.elements().products.gwp)

            let gwpBundleProperties = { _bundle_id: bundleId, _isgift: true };
            if(this.elements().products.gwp_mto != "" && this.elements().products.gwp_mto != null){
                gwpBundleProperties._mto = this.elements().products.gwp_mto;
            }

            if (this.elements().products.gwp) {
                itemsArray.push({
                    id: this.elements().products.gwp.variants[0].id,
                    quantity: 1,
                    properties: gwpBundleProperties
                })
            }
    
    
            if (this.state.step1Value.data === "sv" || this.state.step1Value.data === "prg") {
                opticalProduct = this.state.step1Value.data === "sv" ? this.elements().products["single_vision"] : this.elements().products["progressive_vision"];
                if (opticalProduct) {
                    let opticalVariants = opticalProduct.variants.find((variant) => variant.sku === selectedSku) || false;
                    if (opticalVariants) {
                        let gwpProduct = false;
                        let mto = "";
                        if (this.state.step1Value.data === "sv" && this.elements().products["single_vision_gwp"] != null) {
                            gwpProduct = this.elements().products["single_vision_gwp"];
                            mto = this.elements().products["single_vision_gwp_mto"];
                        }else if(this.state.step1Value.data === "prg" && this.elements().products["progressive_vision_gwp"] != null){
                            gwpProduct = this.elements().products["progressive_vision_gwp"];
                            mto = this.elements().products["progressive_vision_gwp_mto"];
                        }

                        let gwpEyeBundleProperties = { _bundle_id: bundleId };
                        if(mto != "" && mto != null) {
                            gwpEyeBundleProperties._mto = mto;
                        }

                        if (gwpProduct != false) {
                            itemsArray.push({ id: gwpProduct.variants[0].id, quantity: 1, properties: gwpEyeBundleProperties });
                        }

                        let eyegalssVariantScript = JSON.parse(document.querySelector(`[data-eyegalss-lenses="${opticalVariants.featured_image.product_id}"]`).innerText);
                        let eyeglassBundleProperties = { _bundle_id: bundleId, type: "prescription" };
                        if(eyegalssVariantScript[opticalVariants.id] != "" && eyegalssVariantScript[opticalVariants.id] != null){
                            eyeglassBundleProperties._mto = eyegalssVariantScript[opticalVariants.id];
                        }
                        itemsArray.push({ id: opticalVariants.id, quantity: 1, properties: eyeglassBundleProperties });
                    }
                }
            }
    
            if (this.state.step1Value.data === "rr") {
                let readyReadersProduct = this.elements().products["ready_readers"];
                if (readyReadersProduct) {
                    let gwpProduct = this.elements().products["ready_readers_gwp"];
                    
                    let gwpRrBundleProperties = { _bundle_id: bundleId };
                    if(this.elements().products["ready_readers_gwp_mto"] != "" && this.elements().products["ready_readers_gwp_mto"] != null) {
                        gwpRrBundleProperties._mto = this.elements().products["ready_readers_gwp_mto"];
                    }
                    if(gwpProduct) itemsArray.push({ id: gwpProduct.variants[0].id, quantity: 1, properties: gwpRrBundleProperties });

                    let powerBundleProperties = { _bundle_id: bundleId, power: _.state.step2Value[0].value };
                    if(this.elements().products["ready_readers_mto"] != "" && this.elements().products["ready_readers_mto"] != null) {
                        powerBundleProperties._mto = this.elements().products["ready_readers_mto"];
                    }
                    itemsArray.push({ id: readyReadersProduct.variants[0].id, quantity: 1, properties: powerBundleProperties });
                }
            }
    
            if (this.state.step1Value.data === "np") {
                let nonPrescriptionProduct = this.elements().products["non_prescription"];
                if (nonPrescriptionProduct) {
                    let gwpProduct = this.elements().products["non_prescription_gwp"];
                    
                    let gwpProductProperties = { _bundle_id: bundleId };
                    if(this.elements().products["non_prescription_gwp_mto"] != "" && this.elements().products["non_prescription_gwp_mto"] != null) {
                        gwpProductProperties._mto = this.elements().products["non_prescription_gwp_mto"];
                    }
                    if(gwpProduct) itemsArray.push({ id: gwpProduct.variants[0].id, quantity: 1, properties: gwpProductProperties });

                    let eyeglassScript = JSON.parse(document.querySelector('.js-eyeglass-non-prescription').innerText);
                    
                    if (this.state.step2Value.length) {
                        let npbundleProperties = { _bundle_id: bundleId };
                        if(eyeglassScript[nonPrescriptionProduct.variants[1].id] != "" && eyeglassScript[nonPrescriptionProduct.variants[1].id] != null){
                            npbundleProperties._mto = eyeglassScript[nonPrescriptionProduct.variants[1].id]; 
                        }
                        itemsArray.push({ id: nonPrescriptionProduct.variants[1].id, quantity: 1, properties: npbundleProperties });
                    } else {
                        let np1bundleProperties = { _bundle_id: bundleId };
                        if(eyeglassScript[nonPrescriptionProduct.variants[0].id] != "" && eyeglassScript[nonPrescriptionProduct.variants[0].id] != null){
                            np1bundleProperties._mto = eyeglassScript[nonPrescriptionProduct.variants[0].id]; 
                        }
                        itemsArray.push({ id: nonPrescriptionProduct.variants[0].id, quantity: 1, properties: np1bundleProperties });
                    }
                }
            }
    
            let selectedVariant = this.elements().variantPicker.selectedVariant;
            //console.log(selectedVariant);

            let eyeglassMtoValue = "";
            let eyeglassMtoScript = document.querySelector('[mto-eyeglasses-variant-json]');
            if(eyeglassMtoScript) {
                let eyeglassMtoData = JSON.parse(eyeglassMtoScript.textContent);
                eyeglassMtoValue = eyeglassMtoData[selectedVariant.id] || "";
            }

            let bundleProperties = { _main_bundle_id: bundleId };
            if (eyeglassMtoValue !== "") {
                bundleProperties._mto = eyeglassMtoValue;
            }
    
            itemsArray.push({ id: selectedVariant.id, quantity: 1, properties: bundleProperties });
    
            const data = { items: itemsArray };
            //console.log(data);
    
            fetch(`${window.Shopify.routes.root}cart/add.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', }, body: JSON.stringify(data) })
                .then(response => (Promise.all([response, fetch(`${window.Shopify.routes.root}cart.js`, { method: 'GET' }),])))
                .then(([response1, response2]) => Promise.all([response1.json(), response2.json()]))
                .then(([response, cart]) => {
                    if (response.status) {
                        console.error("Product cannot be added", response);
                        document.documentElement.dispatchEvent(new CustomEvent("cart-notification:show", {
                            bubbles: true,
                            cancelable: true,
                            detail: {
                                status: response.ok ? "success" : "error",
                                error: response["description"] || ""
                            }
                        }));
                        button.removeAttribute('aria-busy');
                        return;
                    }
                    button.removeAttribute('aria-busy');
                    document.querySelector("drawer-content").open = false;
                    document.querySelector("popover-content").open = false;
                    document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", {
                        bubbles: true,
                        detail: {
                            cart: cart
                        }
                    }));
                    if (document.getElementById('mini-cart') && window.themeVariables.settings.cartType != "message") {
                        document.getElementById('mini-cart').open = true;
                    }
                    else if (window.themeVariables.settings.cartType == "message") {
                      document.documentElement.dispatchEvent(new CustomEvent("cart-notification:show", {
                        bubbles: true,
                        cancelable: true,
                        detail: {
                            status: "success",
                            error: ""
                        }
                      }));
                    }
                    else {
                        window.location.href = `${window.Shopify.routes.root}cart`
                    }
                    _.resetBuilder();
                });
        },
    
        updatePreview: function () {
            this.elements().preview.forEach((previewSection) => {
                previewSection.innerHTML = ""
                console.log(previewSection)
            });
            let previewHtml = ``;
    
            if (this.state.step1Value) {
                previewHtml += `<p class="options"><span class="option option-name">Lens Type: </span><span class="option option-value">${this.state.step1Value.title}</span></p>`;
            }
    
            if ((this.state.step1Value.data === "sv" || this.state.step1Value.data === "prg" || this.state.step1Value.data === "np") && this.state.step2Value) {
                let step2Values = (this.state.step2Value.map((step2value) => step2value.title)).join(", ");
                previewHtml += `<p class="options"><span class="option option-name">Add-ons: </span><span class="option option-value">${step2Values}</span></p>`;
            }
    
            console.log(this.state.step1Value,this.state.step2Value)
            if (this.state.step1Value.data === "rr" && this.state.step2Value) {
                let step2Values = (this.state.step2Value.map((step2value) => step2value.value)).join(", ");
                previewHtml += `<p class="options"><span class="option option-name">Add-ons: </span><span class="option option-value">${step2Values}</span></p>`;
            }
    
            if (this.state.step3Value) {
                previewHtml += `<p class="options"><span class="option option-name">Lens Design: </span><span class="option option-value">${this.state.step3Value.title}</span></p>`;
            }
            if (previewHtml.length) {
                this.elements().preview.forEach((previewSection) => {
                    previewSection.closest(".lens-selection") ? previewSection.closest(".lens-selection").classList.remove("hidden") : "";
                });
                // this.elements().preview.closest(".lens-selection").classList.remove("hidden");
            }
    
            this.elements().preview.forEach((previewSection) => {
                previewSection.innerHTML = previewHtml
            });
            // this.elements().preview.innerHTML = previewHtml;
    
            let selectedVariant = this.elements().variantPicker.selectedVariant;
            let subTotal = selectedVariant.price;
            if (this.state.step1Value) {
                subTotal += this.state.step1Value.price;
                // console.log("After step1", subTotal);
            }
    
            if (this.state.step2Value.length) {
                for (let item of this.state.step2Value) {
                    subTotal += item.price;
                }
                // console.log("After step2", subTotal);
            }
    
            if (this.state.step3Value) {
                subTotal += this.state.step3Value.price;
                // console.log("After step3", subTotal);
            }
    
            // console.log("Subtotal", subTotal);
            const currencyFormat = window.themeVariables.settings.currencyCodeEnabled ? window.themeVariables.settings.moneyWithCurrencyFormat : window.themeVariables.settings.moneyFormat;
            this.elements().builderSubtotal.forEach((subtotalElement) => {
                let builderSubtotal = `<span class="price price--large"><span class="visually-hidden">Sale price</span>${window.formatMoney(subTotal, currencyFormat)}</span>`;
                subtotalElement.innerHTML = builderSubtotal;
            })
            if (!this.elements().addBundleToCartBtn.classList.contains("hidden")) {
                let buttonPriceElement = document.createElement('span');
                buttonPriceElement.classList.add('js-btn-subtotal-text');
                buttonPriceElement.innerHTML = `<span> - </span><span class="price price--small"><span class="visually-hidden">Sale price</span>${window.formatMoney(subTotal, currencyFormat)}</span>`;
                if(this.elements().addBundleToCartBtn.querySelector('.js-btn-subtotal-text')) this.elements().addBundleToCartBtn.querySelector('.js-btn-subtotal-text').remove();
                this.elements().addBundleToCartBtn.querySelector('.loader-button__text').appendChild(buttonPriceElement);
            }
        },
    }
    EyeGlassBuilder.init();
    // })();